import api from '@/services/api';

class LprTapwaySettingService {

    updateTapwaySettings(request) {
        return api.put('/lpr/tapway/settings', request.body);
    }
}

export default new LprTapwaySettingService();